import { render, staticRenderFns } from "./Test32.vue?vue&type=template&id=212da2ea&scoped=true&"
import script from "./Test32.vue?vue&type=script&lang=js&"
export * from "./Test32.vue?vue&type=script&lang=js&"
import style0 from "@/assets/poliglotiki/main.css?vue&type=style&index=0&lang=css&"
import style1 from "./Test32.vue?vue&type=style&index=1&id=212da2ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212da2ea",
  null
  
)

export default component.exports